import React from "react"
import Stroke from "../../../../../ui/atoms/Stroke"
import FiltersBar from "../../bars/FiltersBar"

interface Props {
  orderByExpanded: boolean
  onFiltersClick: () => void
  onOrderByClick: () => void
}

const MobileFilters = ({
  orderByExpanded,
  onFiltersClick,
  onOrderByClick,
}: Props) => {
  return (
    <div>
      <Stroke noMargin color="disabled" />
      <div>
        <FiltersBar
          orderByExpanded={orderByExpanded}
          onFiltersClick={onFiltersClick}
          onOrderByClick={onOrderByClick}
        />
      </div>
      <Stroke noMargin color="disabled" />
    </div>
  )
}

export default MobileFilters
